export const GET_CONFIG_REQUEST = 'GET_CONFIG_REQUEST';
export const GET_CONFIG_RESPONSE = 'GET_CONFIG_RESPONSE';
export const GET_CONFIG_FAILURE = 'GET_CONFIG_FAILURE';
